import UserFragment from './UserFragment';
export default `
  query Me{
    me {
      ...UserFragment
    }
  }
  ${UserFragment}
`;
